var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeHills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 650,
    viewBox: "0 0 1920 650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.005,
    x2: 0.5,
    y2: 0.983,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b88ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4f8eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#769aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#8fa2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#98a5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3f4fd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sky",
    d: "M0,0H1920V650H0Z",
    transform: "translate(0.41)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home_hills",
    transform: "translate(-0.41)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Sun",
    cx: 71.77,
    cy: 71.77,
    r: 71.77,
    transform: "translate(1012.44 263.13)",
    fill: "#ffe6b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hills",
    transform: "translate(0 -107.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1008.73,795.91H.1V268.65H191.32c33.68-4.4,47.03,7.78,50.31,11.12,5.48,5.6,11.53,15.89,17.56,26.12,3.78,6.46,6.7,11.99,8.68,15.86,4.88-4.43,54.26-47.75,98.33-30.74a59.516,59.516,0,0,1,16.51,9.67,31.426,31.426,0,0,1,18.28,2.56c14.11,6.72,17.25,22.01,17.61,23.83,5.55-1.63,14.12-4,24.76-6.36,23.59-5.22,23.66-2.89,35.07-6.82,15.05-5.22,20.72-11.27,30.79-9.04a25.565,25.565,0,0,1,11.24,5.91c7.46,2.7,12.23,6.32,11.79,9.14a2.927,2.927,0,0,1-.96,1.7l-.31.29c11.56,1.34,29.81,3.21,52.37,4.5,54.9,3.16,67.66-1.12,81.8,10.89,11.01,9.33,18.25,24.62,32.63,37.73a46.833,46.833,0,0,1,8.49,9.95,48.122,48.122,0,0,1,6.41,16.15c27.39,17.78,51.29,35.14,71.63,51.03,16.67,13.01,31.01,25,42.9,35.41,60.53,52.87,117.9,103.73,152.42,176.63a317.656,317.656,0,0,1,16.12,41.01c7.63,24.07,11.17,44.74,12.94,90.41a1.883,1.883,0,0,1,.02.33Z",
    transform: "translate(0.41)",
    fill: "#f37771"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M855.16,795.29.1,795.91V268.65H191.32c33.68-4.4,47.03,7.78,50.31,11.12a46.726,46.726,0,0,1,4.21,5.02h.02c4.28,5.74,8.8,13.42,13.33,21.1,3.78,6.46,6.7,11.99,8.68,15.86,4.88-4.43,54.26-47.75,98.33-30.74a59.516,59.516,0,0,1,16.51,9.67,31.426,31.426,0,0,1,18.28,2.56c14.11,6.72,17.25,22.01,17.61,23.83,5.55-1.63,14.12-4,24.76-6.36,23.59-5.22,23.66-2.89,35.07-6.82,15.05-5.22,20.72-11.27,30.79-9.04a23.708,23.708,0,0,1,8.21,3.59,29.853,29.853,0,0,1,3.04,2.32c.91.33,1.79.67,2.61,1.03,5.93,2.54,9.57,5.62,9.19,8.11a2.927,2.927,0,0,1-.96,1.7l-.31.29c-11.51,2.94-118.57,31.72-135.82,103.59-1.67,6.99-5.19,22.39.48,39.52,15.72,47.39,85.69,59.35,93.47,60.58a142.488,142.488,0,0,0,21.84,1.79,9.593,9.593,0,0,1,6.67,2.82,174.462,174.462,0,0,0,32.99,25.55c19.19,11.44,37.18,16.96,58.04,36.77,2.51,2.42,4.5,4.47,5.81,5.86,12.99-10.67,23.42-12.56,30.29-12.44,1.12.02,2.2.1,3.23.22,14.14,1.58,22.46,11.91,45.41,18.3a108.867,108.867,0,0,0,17.39,3.37,9.489,9.489,0,0,1,8.13,7.25c1.82,7.51,3.45,15.55,4.78,24.09q1.5,9.66,2.32,18.54a105.487,105.487,0,0,1,17.23-11.51c13.3-7.11,28.47-15.17,41.36-10.19,12.87,4.98,20.81,21.94,20.98,41.36l23.71,7.06a9.479,9.479,0,0,1,6.24,6.17,20.909,20.909,0,0,0,5.07,8.37c3.56,3.49,6.72,3.8,9.57,7.89a19.114,19.114,0,0,1,3.11,9.86c.67,8.9,1.53,38.45,1.84,78.57Z",
    transform: "translate(0.41)",
    fill: "#e15959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M850.21,706.87c-4.47.68-9.22,1.56-14.19,2.69-5.57,1.26-10.74,2.68-15.51,4.17,5.67-3.03,11.77-5.99,18.29-8.8,2.12-.91,4.23-1.78,6.3-2.61a15.512,15.512,0,0,1,3.21,2.36A15.3,15.3,0,0,1,850.21,706.87Z",
    transform: "translate(0.41)",
    fill: "#c53e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M267.88,321.77a45.9,45.9,0,0,0-4.19,4.86,41.859,41.859,0,0,0-5.55,10.19A123.943,123.943,0,0,0,256.51,319a127.226,127.226,0,0,0-10.67-34.19h.02c4.28,5.74,8.8,13.42,13.33,21.1,3.78,6.46,6.7,11.99,8.68,15.86Z",
    transform: "translate(0.41)",
    fill: "#c53e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M382.71,300.69q-14.67,5.55-30.42,12.43c-10.85,4.77-21.09,9.64-30.72,14.51a328.184,328.184,0,0,1,31.8-19.76c8.09-4.4,15.9-8.22,23.33-11.53,1.29.83,2.63,1.75,3.99,2.78.7.53,1.37,1.05,2.01,1.58Z",
    transform: "translate(0.41)",
    fill: "#c53e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M418.6,327.08q-25.635,7.32-52.33,15.75-23.325,7.395-45.49,15.05a693.731,693.731,0,0,1,66.56-27.44q15.015-5.295,29.38-9.62c.33.82.64,1.7.94,2.64.4,1.28.71,2.49.94,3.61Z",
    transform: "translate(0.41)",
    fill: "#c53e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M523.08,311.79a60.859,60.859,0,0,0-11.65,4.64c-1.89,1-3.64,2.03-5.22,3.06a87.6,87.6,0,0,1,7.42-7.75c1.29-1.17,2.56-2.3,3.8-3.3a29.853,29.853,0,0,1,3.04,2.32c.91.33,1.79.67,2.61,1.03Z",
    transform: "translate(0.41)",
    fill: "#c53e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M784.32,452.13c-6.53,9.67-15.93,9.45-18.06,17.03-1.29,4.55,1.15,7.89-1.24,10.02-1.87,1.67-5.05,1.15-7.39.48.79,2.92,2.2,9.88-1.12,16.91-.91,1.94-1.89,4.02-2.89,3.92-2.34-.24-3.16-11.99-3.4-24.71a65.877,65.877,0,0,1-8.95-8.95c-12.54-15.14-8.64-24.23-19.45-40.43-7.61-11.39-16.29-17.01-14.04-21.91.88-1.96,3.13-2.92,4.93-3.4,27.39,17.78,51.29,35.14,71.63,51.03Z",
    transform: "translate(0.41)",
    fill: "#e15959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M799.03,463.82c3.5,9.65,6.91,19.88,10.14,30.66,4.47,14.97,8.07,29.28,10.96,42.75q-3.09-22.86-6.64-46.15-1.35-8.85-2.74-17.63-2.715-2.265-5.49-4.55c-2.08-1.72-4.16-3.41-6.23-5.09Z",
    transform: "translate(0.41)",
    fill: "#e15959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M405.61,400.33c2.77,7.29,6.8,18.21,11.36,31.64,7,20.63,9.96,31.66,10.65,31.49,1.38-.35-8.82-45.24-9.96-50.24-2.16-9.46-4.03-17.29-5.35-22.68-1.5,1.95-3.02,4.06-4.52,6.34-.77,1.17-1.5,2.32-2.18,3.46Z",
    transform: "translate(0.41)",
    fill: "#e15959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M488.4,336.62a108.161,108.161,0,0,1,5.67,13.07c2.65,7.41,3.6,12.64,3.86,12.58.4-.09-1.95-12.86-4.1-23.26-.36-1.75-.68-3.22-.9-4.29-.74.3-1.48.61-2.22.92-.77.33-1.54.65-2.3.98Z",
    transform: "translate(0.41)",
    fill: "#e15959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M626.49,466.46c-2.99.02-8.04-29.24-2.08-31.72,1.5-.62,3.46.55,4.4,1.39,1.69,1.51,2.65,4.26,1.11,15.07-1.43,10.05-2.17,15.25-3.43,15.26Z",
    transform: "translate(0.41)",
    fill: "#e15959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M926.48,721.29a400.324,400.324,0,0,0-7.88-66.14c-5.96-29.15-13.76-50.78-13.27-50.93.53-.16,9.49,25.11,18.21,56.18,4.5,16.01,7.75,29.36,9.87,38.48-1.07,3.07-2.13,6.23-3.15,9.49q-2.085,6.63-3.77,12.92Z",
    transform: "translate(0.41)",
    fill: "#e15959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M648.01,586.15a38.372,38.372,0,0,0-8.09,1.39c-3.35.98-8.54,3.01-18.18,11.34-9.95,8.59-15.65,13.52-19.09,22.46a39.786,39.786,0,0,0-2.32,9.21,10.494,10.494,0,0,0-1.72-5.96c-.69-1-1.32-1.94-1.99-1.87-3.3.41-2.2,26.56-3.68,26.63-.19.02-.67-.41-1.87-8.09-1.72-11.2-2.58-16.79-1.7-19.71,1.39-4.47,5.67-7.99,14.21-15.02,4.43-3.64,8.28-6.39,10.91-8.16,12.99-10.67,23.42-12.56,30.29-12.44,1.12.02,2.2.1,3.23.22Z",
    transform: "translate(0.41)",
    fill: "#c53e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1008.7,795.58H463.89V587.54a179.376,179.376,0,0,1,31.48,12.97,198.727,198.727,0,0,1,28.71,18.83c18.64,14.14,23.37,21.44,29.9,26.51.02.02.05.05.05.07a38.265,38.265,0,0,0,10.19,5.53c6.82,2.63,11.96,3.23,16.03,4.57a13.409,13.409,0,0,1,7.42,5.31c5.14,7.42-.55,12.37,4.33,24.09,4.11,9.9,9.98,10.65,15.12,22.54a50.493,50.493,0,0,1,3.85,14.35,80.4,80.4,0,0,0,21.77-16.67c12.58-13.76,16.17-27.92,33.25-34.71,1.67-.67,2.92-1.05,3.33-1.17,19.02-5.57,39.02,7.75,49.55,16.2.91-.36,7.25-2.73,13.42.69a16.151,16.151,0,0,1,7.87,15.74c13.16-16.32,27.8-27.78,35.67-24.21a7.782,7.782,0,0,1,1.44.89c7.66,5.93,8.06,29.19-1.6,58.83a187.624,187.624,0,0,1,59.14-21.8,7.16,7.16,0,0,1,4,.38,6.481,6.481,0,0,1,1.96,1.15c.72.6,1.46,1.22,2.2,1.91a49.676,49.676,0,0,1,3.56,3.54,30.56,30.56,0,0,1,8.95-.45,26.892,26.892,0,0,1,4.47.77q.54-8.97.93-18.21c.14-3.25.26-6.48.36-9.71a7.165,7.165,0,0,1,7.58-6.94c2.03.14,4.09.24,6.24.29,4.45.1,8.66,0,12.61-.24a16.875,16.875,0,0,0,12.32-6.6c1.15-1.53,2.32-3.06,3.47-4.59,3.23-4.28,6.34-8.52,9.4-12.73a11.973,11.973,0,0,1,8.97-4.98c4.95-.29,10.14-.43,15.6-.36a213.735,213.735,0,0,1,42.2,4.86,317.656,317.656,0,0,1,16.12,41.01c7.63,24.07,11.17,44.74,12.94,90.41Z",
    transform: "translate(0.41)",
    fill: "#d20f4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M1919.96,240.26V795.91H951.93c-9.95-9.78-22.39-25.22-26.56-46.29-4.35-22.2,3.54-35.14,18.54-82.44,20.43-64.45,13.35-64.31,25-81.48a85,85,0,0,1,23.49-23.71c13.49-9.28,28.59-15.55,48.28-34.64a91.8,91.8,0,0,0,14.67-17.89c6.75-10.34,16.05-26.87,34.98-59.83,61.48-107.01,78.92-133.52,114.16-150.82,9.59-4.71,19.35-7.51,38.88-13.11,0,0,52.2-14.98,125.6-10.24a34.738,34.738,0,0,1,17.44,5.41,32.825,32.825,0,0,1,10.05,10.81,29.655,29.655,0,0,1,5.26-2.22c8.09-2.58,15.12-1.2,18.04-.72,5.98.98,14.86,1.32,27.32-1.53a643.058,643.058,0,0,1,59.64-68.37c7.56-7.54,15.67-15.24,24.33-23.01,66.44-59.62,99.67-89.43,139.52-88.28,19.31.55,33.97,7.58,48.42,18.33v.02c31.94,23.73,62.82,65.62,140.27,96.15a379.253,379.253,0,0,0,60.69,18.23Z",
    transform: "translate(0.41)",
    fill: "#e15959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M1156.95,646.82c.97-2,6.76-14.39.91-24.54-3.83-6.63-10.63-8.83-18.87-11.36-7.96-2.44-25.13-7.7-42.23-1.46-12.22,4.46-18.05,12.48-35.04,37-38.39,55.41-38.61,57.8-37.5,59.31,4.47,6.1,31.48-.6,132.74-58.96Z",
    transform: "translate(0.41)",
    fill: "#c53e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M1031.89,795.91a1280.86,1280.86,0,0,0,152.8-199.11q20.385-32.8,37.54-64.55a23.834,23.834,0,0,1,12.26-10.88c21.3-8.31,43.82-16.47,67.5-24.27,26.79-8.83,52.67-16.42,77.45-22.95a47.685,47.685,0,0,0,26.62-18.24q13.365-18.63,26.82-39.07,12.21-18.585,23.07-36.59a119.348,119.348,0,0,1,53.49-47.43q30.93-13.755,64.2-27.11c48.75-19.5,95.57-35.81,139.86-49.5a47.451,47.451,0,0,1,16.06-2.07c20.41.87,37.61,2.77,50.91,4.65,18.31,2.59,27.15,4.85,36.27,10.65a68.148,68.148,0,0,1,23.15,25.47V795.92H1031.88Z",
    transform: "translate(0.41)",
    fill: "#921c5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M1019.54,569.64c-11.91.98-21.75-4.14-27.13-7.66,13.49-9.28,28.59-15.55,48.28-34.64a91.8,91.8,0,0,0,14.67-17.89c4.4,1.46,6.75,3.64,8.01,5.86C1071.17,529.19,1048.85,567.2,1019.54,569.64Z",
    transform: "translate(0.41)",
    fill: "#c53e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1158.99,338.26a67.057,67.057,0,0,0,22.69,10.82c7.52,1.95,14.8,2.39,15.05,1.39.32-1.26-10.86-3.08-21.3-12.04a49.756,49.756,0,0,1-8.72-9.79c-1.46,1.72-2.94,3.51-4.42,5.37q-1.71,2.145-3.3,4.25Z",
    transform: "translate(0.41)",
    fill: "#c53e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1309.87,338.89a458.3,458.3,0,0,0,49.7,23.46q10.8,4.335,21.15,7.87a116.313,116.313,0,0,1-34.42-9.72,218.153,218.153,0,0,1-20.37-11.27c-6.68-4.03-12.14-7.65-16.05-10.34Z",
    transform: "translate(0.41)",
    fill: "#c53e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M1506.73,218.82a383.084,383.084,0,0,0-29.23,39.35c-24.64,38.09-32.25,65.07-62.82,93.37-18.49,17.11-23.8,14.76-25,14.04-6.72-4,2.56-24.4.88-47.87a43.2,43.2,0,0,1,1.89-17.42,40.781,40.781,0,0,1,4.02-8.64,29.655,29.655,0,0,1,5.26-2.22c8.09-2.58,15.12-1.2,18.04-.72,5.98.98,14.86,1.32,27.32-1.53a643.058,643.058,0,0,1,59.64-68.37Z",
    transform: "translate(0.41)",
    fill: "#c53e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M1919.96,240.26V294.9h-80.07c-7.87-15-17.75-22.2-23.16-25.45-12.73-7.68-27.58-9.64-41.22-11.46-3.52-.48-6.44-.74-8.42-.91,8.42-1.53,15.65-2.99,21.36-4.19,24.5-5.19,20.31-5.57,31.39-7.37,10.81-1.77,14.76-1.48,16.03-4.33,1.94-4.26-4.11-10.89-8.95-16.05-8.21-8.83-14.02-11.75-24.55-19.28-20.65-14.83-21.77-20.45-30.69-20.84-5.38-.24-6.41,1.7-21.63,8.18-15.93,6.77-33.88,12.73-34.57,11.27-.48-1.08,8.21-5.41,21.32-14.21a291.21,291.21,0,0,0,24.83-18.68,188.6,188.6,0,0,1-22.85-20.67,191.6,191.6,0,0,1-19.79-25.02c31.94,23.73,62.82,65.62,140.27,96.15a379.253,379.253,0,0,0,60.69,18.23Z",
    transform: "translate(0.41)",
    fill: "#c53e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1542.16,503.73a164.41,164.41,0,0,1-57.88-31.95,162.676,162.676,0,0,1-28.25-31.49,173.1,173.1,0,0,0,92.61,46.31Z",
    transform: "translate(0.41)",
    fill: "#7c1452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1613,411.59c-15.65-1.25-49.44-6.23-81.03-31.02a145.28,145.28,0,0,1-31.49-34.27c11.96,12.77,37.59,36.4,77.33,47.23a161.058,161.058,0,0,0,46.77,5.56L1613,411.59Z",
    transform: "translate(0.41)",
    fill: "#7c1452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M1708.85,342.13A91.588,91.588,0,0,1,1663.01,325a89.981,89.981,0,0,1-22.23-23.62,125.444,125.444,0,0,0,90.3,31.95q-11.115,4.395-22.23,8.8Z",
    transform: "translate(0.41)",
    fill: "#7c1452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M859.95,723.37c-.86,25.11-.79,49.21,0,72.2h59.41a34.282,34.282,0,0,0-.68-13.55c-1.31-5.06-3.16-7.13-2.08-9.03,2.46-4.36,15.9-.05,16.44-1.85.42-1.39-6.92-6-16.21-8.57-9.32-2.57-14.43-1.38-15.98-4.63-1.65-3.46,2.38-8.52,3.7-10.19,4.92-6.18,11.89-7.84,14.59-8.33a69.84,69.84,0,0,0-21.08,4.83c-10.08,4.07-12.61,7.92-16.41,7.62-5.98-.47-13.59-11.12-20.32-57.25Q860.46,708.735,859.95,723.37Z",
    transform: "translate(0.41)",
    fill: "#a70548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M859.95,795.58H703.78l-176.61.33V668.11q28.455,28.38,57.11,60.19,8.355,9.3,16.36,18.52a31.305,31.305,0,0,1,6.48-1.22c20.29-1.6,29.55,18.9,52.78,20.57a38.382,38.382,0,0,0,14.09-1.53c12.97-4.09,20.17-14.62,22.97-19.35a37.258,37.258,0,0,0,16.99,14.21c19.45,7.8,37.7-5.6,38.9-6.48a120.289,120.289,0,0,0,24.42-73.97c7.66,5.93,8.06,29.19-1.6,58.83a187.624,187.624,0,0,1,59.14-21.8,7.16,7.16,0,0,1,4,.38c-12.66,6.53-27.61,14.4-44.31,23.59-13.45,7.37-18.92,10.6-18.52,13.88.55,4.23,10.91,8.18,44.76,9.88l38.61,1.45.6,30.32Z",
    transform: "translate(0.41)",
    fill: "#a70548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M580.25,656a19.031,19.031,0,0,0-9.4,6.24,18.587,18.587,0,0,0-3.16,5.86,74.033,74.033,0,0,0-4.64-9.71,71.135,71.135,0,0,0-9.02-12.49,38.265,38.265,0,0,0,10.19,5.53C571.04,654.06,576.18,654.66,580.25,656Z",
    transform: "translate(0.41)",
    fill: "#a70548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M718.87,685.93c-2.29,3.29-4.8,6.68-7.56,10.12a186.153,186.153,0,0,1-16.36,17.9c8.91-6.46,18-13.54,27.16-21.3q4.125-3.5,8.06-6.98a17.008,17.008,0,0,0-6.9-.77,16.638,16.638,0,0,0-4.41,1.04Z",
    transform: "translate(0.41)",
    fill: "#a70548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M624.73,794.67.1,795.91V170.35c.72-.53,1.48-1.08,2.32-1.65,17.23-12.06,55.77-34.93,97.37-24.76,16.22,3.97,28.42,11.87,38.42,19.93,88.42,71.1,107.39,235.84,160.22,258.83a108.454,108.454,0,0,1,24.38,13.59c13.04,9.74,21.2,20.62,33.49,37.35,4.57,6.2,10.84,15.07,17.75,26.24,5.5,1.48,11.48,2.85,17.92,4.02,5.17.93,10.12,1.63,14.81,2.15,6.39,9.78,12.82,20.29,19.14,31.48q5.6,9.9,10.5,19.45a123.925,123.925,0,0,1,58.95,43.52C511.88,622.39,560.75,695,624.73,794.67Z",
    transform: "translate(0.41)",
    fill: "#921c5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M107.66,311.26q-22.245-28.38-46.32-57.42Q30.53,216.64.1,182.53V170.35c.72-.53,1.48-1.08,2.32-1.65q9.225,11.7,18.49,23.71Q67.425,252.74,107.66,311.26Z",
    transform: "translate(0.41)",
    fill: "#7c1452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M178.67,208.34a99.05,99.05,0,0,0-3.1,15.25c-.67,5.53-.33,6.83,0,7.72,1.62,4.31,6.07,6.3,12.97,9.26a71.506,71.506,0,0,0,12.1,3.96c-3.43-6.49-7.27-13.26-11.55-20.22C185.62,218.66,182.13,213.34,178.67,208.34Z",
    transform: "translate(0.41)",
    fill: "#7c1452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M374.05,499.88l-2.69,19.83q17.715-6.825,35.42-13.66c-5.3-.59-10.96-1.41-16.94-2.55-5.63-1.07-10.9-2.31-15.78-3.62Z",
    transform: "translate(0.41)",
    fill: "#7c1452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M436.42,556.98c4.81,13.71,9.45,25.27,13.27,34.27,10.02,23.59,16.15,33.6,20.5,40.06,2.75,4.08,5.21,7.37,6.97,9.64",
    transform: "translate(0.41)",
    fill: "#7c1452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M530.88,768.13h77.18A27.843,27.843,0,0,0,583.9,757.8q-5.385-10.395-10.65-21.62c-.4-.86-.79-1.71-1.19-2.56a14.308,14.308,0,0,0-12.18-8.33c-1.68-.1-3.4-.17-5.15-.22a189.894,189.894,0,0,0-19.91.46q-1.965,21.3-3.94,42.6Z",
    transform: "translate(0.41)",
    fill: "#6d124d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M540.32,725.19c-.31,5.84-.69,11.72-1.12,17.7-.6,8.56-1.29,16.99-2.08,25.24H315.11V578.96c9.79,1.03,18.95,2.32,27.46,3.78a365.041,365.041,0,0,1,54.71,13.59c17.08,5.69,31.12,11.91,40.53,25.93a55.384,55.384,0,0,1,8.09,19.69c4.93-3.33,12.75-7.46,22.25-7.18,20.96.62,35.43,22.46,49.07,43.06a203.464,203.464,0,0,1,23.11,47.35Z",
    transform: "translate(0.41)",
    fill: "#4a2477"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M520.73,768.14H315.1V578.97c9.79,1.03,18.95,2.32,27.46,3.78a240.663,240.663,0,0,0,67.68,75.65,235.442,235.442,0,0,0,41.24,23.81,23.836,23.836,0,0,1,12.97,14.43,233.85,233.85,0,0,0,21.95,48.33,55.584,55.584,0,0,1,22.46,7.87,28.316,28.316,0,0,1,7.49,6.34,24.289,24.289,0,0,1,4.35,8.95Z",
    transform: "translate(0.41)",
    fill: "#3a196d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M427.93,639.71c.78-1.3,9.89,1.89,17.29,7.1,4.01,2.82,6.65,5.62,10.8,10.03,3.05,3.23,9.91,10.51,9.11,11.42-1.08,1.23-15.46-9.89-20.84-14.05-9.96-7.7-17.12-13.24-16.36-14.51Z",
    transform: "translate(0.41)",
    fill: "#3a196d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M360.49,768.14H.1V198.27c22.18,23.49,45.17,49.57,68.35,78.42,19.9,24.76,37.87,49,54.09,72.3q1.29,1.83,2.68,3.59a67.945,67.945,0,0,0,37.37,24.04,1.123,1.123,0,0,1,.31.1A166.741,166.741,0,0,0,181.66,380a68.906,68.906,0,0,1,15.45,3.59,72.709,72.709,0,0,1,26.96,17.06,782.6,782.6,0,0,1,59.24,66.2,782.663,782.663,0,0,1,46.75,65.36,71.309,71.309,0,0,1,11.12,33.92q1.68,26.625,3.85,53.83c4.04,50.98,9.16,100.38,15.07,148.18.12,1.03.26,2.06.38,3.09",
    transform: "translate(0.41)",
    fill: "#4a2477"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M285.1,469.11a201.726,201.726,0,0,1,4.99,26.29,203.586,203.586,0,0,1,0,49.08q2.955-19.7,5.33-40.52,1.08-9.555,1.97-18.89-2.565-3.42-5.21-6.87-3.54-4.62-7.08-9.09Z",
    transform: "translate(0.41)",
    fill: "#3a196d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M209.84,509.45a84.689,84.689,0,0,1-4.33,23.76c.17-5.98.12-12.49-.31-19.43q-.2-3.27-.48-6.39a47.873,47.873,0,0,0-4.76-16.9q-5.76-11.61-11.72-23.34-30.72-60.18-63.02-114.57a67.945,67.945,0,0,0,37.37,24.04,1.123,1.123,0,0,1,.31.1A166.741,166.741,0,0,0,181.66,380a68.906,68.906,0,0,1,15.45,3.59c-7.34.91-14.67,3.37-18.16,9.16-3.83,6.36-1.22,13.71,5.57,31.51,18.83,49.45,26,64.79,25.31,85.19Z",
    transform: "translate(0.41)",
    fill: "#3a196d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M.15,375.86a252.926,252.926,0,0,1,29.02,23.69,253.343,253.343,0,0,1,26.86,29.87,175.176,175.176,0,0,0-37.04-29.4A175.138,175.138,0,0,0,.11,390.34q.03-7.245.05-14.48Z",
    transform: "translate(0.41)",
    fill: "#3a196d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M0,483.01q63.78,27.81,131.74,61.47c51.9,25.84,100.67,52.11,146.32,78.25H0V483.01Z",
    transform: "translate(0.41)",
    fill: "#3a196d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M513.74,779.71,318.5,778.54,0,776.63V516.17c210.51,70.91,363.33,125.17,393.79,137.44,10.43,4.21,28.4,12.32,44.07,29.5a117.536,117.536,0,0,1,17.08,24.83,148.193,148.193,0,0,1,9.64,22.2,155.249,155.249,0,0,1,7.25,33.35,213.6,213.6,0,0,1,22.46,3.01c13.18,2.51,17.56,4.67,19.04,8.37a8.818,8.818,0,0,1,.41,4.83Z",
    transform: "translate(0.41)",
    fill: "#2a0a4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M246.11,642.18q-2.625,7.785-246.1-65.1V542.06Q248.74,634.22,246.11,642.18Z",
    transform: "translate(0.41)",
    fill: "#1e053f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M335.47,677.53c21.41,1.8,36.73,7.52,46.46,12.19,8.27,3.97,16.5,9.1,26.39,15.28,9.8,6.11,17.75,11.53,23.31,15.43q-48.075-21.45-96.16-42.91Z",
    transform: "translate(0.41)",
    fill: "#1e053f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M513.74,779.71,318.5,778.54c-8.4-2.34-82.61-23.73-83.35-57.06a17.506,17.506,0,0,1,2.15-9.55c15.17-24.67,111.92,9.09,142.01,20.07,2.87-6.79,6.17-8.9,8.64-9.57,6-1.65,9.86,4.45,22.23,7.42,6.82,1.63,14.21,1.82,14.5.62.24-.96-3.61-3.33-21.84-9.57a57.49,57.49,0,0,0,18.54-2.08c4.47-1.29,4.19-1.82,6.89-2.44,2.11-.48,9.86-1.89,30.5,10.19,1.67.98,3.64,2.18,5.81,3.56a155.249,155.249,0,0,1,7.25,33.35,213.6,213.6,0,0,1,22.46,3.01c13.18,2.51,17.56,4.67,19.04,8.37a8.818,8.818,0,0,1,.41,4.83Z",
    transform: "translate(0.41)",
    fill: "#1e053f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M56.03,535.11,32.95,467.46,0,454.96v80.15Z",
    transform: "translate(0.41)",
    fill: "#1e053f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M1481.4,511.84V795.91H982.71a71.249,71.249,0,0,1,.79-10.5c.57-3.97.89-6.05,1.84-8.01,2.85-5.81,10.12-7.85,13.8-8.56a172.976,172.976,0,0,1,3.33-22.92c1.48-6.84,2.92-11.27,3.85-19a105.448,105.448,0,0,0,.79-14.67,120.506,120.506,0,0,1,26.53-12.87c6.2-2.11,11.22-3.21,19.45-6.72a124.611,124.611,0,0,0,15.74-8.11c86.08-51.36,121.1-76.63,121.1-76.63,22.11-15.96,49.67-36.82,80.55-62.75a28.56,28.56,0,0,1,14.04-6.41,390.311,390.311,0,0,1,112.6-1.22,188.174,188.174,0,0,1,84.26-25.7Z",
    transform: "translate(0.41)",
    fill: "#2a0a4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M1038.29,732.94c.45,1.51,2.58,1.94,3.8,2.42,4.57,1.87,8.73,9.81,7.78,35.55,1.58-.17,7.2-.62,10.5,2.97.79.86,1.87,2.39,2.68,8.37a67.039,67.039,0,0,1,.48,13.66H982.72a71.249,71.249,0,0,1,.79-10.5c.57-3.97.89-6.05,1.84-8.01,2.85-5.81,10.12-7.85,13.8-8.56a172.976,172.976,0,0,1,3.33-22.92c1.48-6.84,2.92-11.27,3.85-19a105.448,105.448,0,0,0,.79-14.67,15.422,15.422,0,0,1,6.17,1c6.41,2.54,7.25,8.35,10.65,10.89,10.19,7.63,40.67-16.53,41.2-15.74.21.29-3.71,3.9-14.14,11.94-8.61,6.63-13.49,10-12.7,12.61Z",
    transform: "translate(0.41)",
    fill: "#1e053f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M1383.44,537.53a93.44,93.44,0,0,0-9.61,9.15,94.494,94.494,0,0,0-9.38,12.15,56.8,56.8,0,0,1,7.99-16.44,55.241,55.241,0,0,1,4.59-5.67c1.33.16,2.66.32,4.01.49.81.1,1.61.21,2.4.31Z",
    transform: "translate(0.41)",
    fill: "#1e053f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M1383.44,636.17V795.91H1038a627.636,627.636,0,0,0,103.42-138.78,34,34,0,0,1,18.21-15.69,30.714,30.714,0,0,1,4.43-1.27,184.642,184.642,0,0,0,25.81-7.25,191.2,191.2,0,0,0,47.23-24.9,34.537,34.537,0,0,1,10.5-5.1h.02a33.417,33.417,0,0,1,12.99-1.1c7.54.86,15.29,1.94,23.25,3.33a401.708,401.708,0,0,1,99.57,31.03Z",
    transform: "translate(0.41)",
    fill: "#d20f4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M1247.63,602.92c-6.7,6.82-46.12,46.44-68.85,48.83-4.55.48-14.52,1.56-18.04-3.83a9.458,9.458,0,0,1-1.1-6.48,30.714,30.714,0,0,1,4.43-1.27,184.642,184.642,0,0,0,25.81-7.25,191.2,191.2,0,0,0,47.23-24.9,34.537,34.537,0,0,1,10.5-5.1h.02Z",
    transform: "translate(0.41)",
    fill: "#a70548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M1205.63,795.91c6.95-12.38,19.15-34.16,34.27-61.43,54.3-97.99,69.99-129.45,100.33-134.59,9.16-1.55,23.5-1.35,42.91,9.57q.15,93.225.31,186.45H1205.64Z",
    transform: "translate(0.41)",
    fill: "#a70548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M1919.96,254.47V795.91H1260.02c17.78-35.84,35.69-76.01,52.47-120.38,12.49-33.04,22.97-64.79,31.77-94.86a95.68,95.68,0,0,1,47.06-57.51c24.33-12.92,49.62-27.49,75.53-43.97,25.02-15.89,48.33-32.15,70.02-48.4,23.73-17.78,45.53-35.57,65.46-52.97q9.225-8.04,17.89-15.98a94.937,94.937,0,0,1,34.47-20.05q69.075-22.605,138.11-45.34,63.63-20.955,127.15-41.99Z",
    transform: "translate(0.41)",
    fill: "#4a2477"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M1920,297.68a1904.636,1904.636,0,0,1-154.96,132.74c-66.8,51.32-116.24,82.32-114.83,84.58,1.36,2.19,49.8-23.59,269.76-154.96l.04-62.36Z",
    transform: "translate(0.41)",
    fill: "#3a196d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M1602.33,377.82a455.581,455.581,0,0,1-33.3,50.43c-31.03,40.81-64.71,70.74-66.68,69-1.34-1.17,13.49-15.55,25.46-41.68a169.281,169.281,0,0,0,9.07-24.79c23.73-17.78,45.53-35.57,65.46-52.97Z",
    transform: "translate(0.41)",
    fill: "#3a196d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M1405.41,647.74c-.86-.5,9.39-19.65,16.67-32.1,15.63-26.75,34.15-51.01,35.19-50.32C1459.13,566.57,1407.23,648.81,1405.41,647.74Z",
    transform: "translate(0.41)",
    fill: "#3a196d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M1464.06,522.26a143.832,143.832,0,0,0,51.4-3.4c6.68,2.53,13.78,4.97,21.3,7.25a337.661,337.661,0,0,0,42.14,9.88c-12.12-3.74-24.75-8.03-37.82-12.97q-13.59-5.13-26.08-10.5c-6.14,1.97-12.89,3.82-20.22,5.4a213.926,213.926,0,0,1-30.72,4.32Z",
    transform: "translate(0.41)",
    fill: "#3a196d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M1541.91,523.34q35.55-37.89,71.1-75.79l-65.37,77.91q-1.5-.54-3-1.11c-.91-.34-1.82-.68-2.72-1.02Z",
    transform: "translate(0.41)",
    fill: "#3a196d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M1305.54,795.91c11.36-12.87,26.45-29.29,44.92-47.69,0,0,23.06-22.97,44.91-42.14,34.29-30.07,124.13-83.9,250.04-138.91Q1505.73,673.2,1507.42,675.52q1.8,2.445,161.14-110.67a27.59,27.59,0,0,1,22.46,11.57q-37.245,29-36.12,30.56,1.095,1.53,38.2-22.69c.4,9.26.43,18.84,0,28.71-3.34,76.74-32.91,139.22-61.12,182.9H1305.54Z",
    transform: "translate(0.41)",
    fill: "#3a196d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M1274.83,795.91a246.729,246.729,0,0,1,28.4-20.37c6.68-4.11,13.15-7.64,19.27-10.68a23.788,23.788,0,0,1,12.75-2.35c9.36.86,19.41,2.16,30.02,4.08,10.8,1.95,20.8,4.29,29.94,6.79,2.94-2.33,6.15-4.72,9.65-7.1q4.29-2.925,8.33-5.33c-.33,2.87.14,4.88,1.39,6.02q11.9,10.83,118.77-82.65a64.111,64.111,0,0,0,21.3,5.32s2.11.15,4.16.16c9.64.04,28.28-9.6,49.32-26.09a148.4,148.4,0,0,0,71.48,21.99,47.713,47.713,0,0,0,46.57-30.92q7.23-18.96,14.15-38.99c1-2.9,1.98-5.78,2.95-8.66a47.97,47.97,0,0,1,34.97-31.61q9.8-2.19,19.96-4.19a802.819,802.819,0,0,1,121.74-14.35V795.91H1274.82Z",
    transform: "translate(0.41)",
    fill: "#2a0a4c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHills);
export default __webpack_public_path__ + "static/media/home_hills.cdd2486e0e4da9ad15afdca4edbe4864.svg";
export { ForwardRef as ReactComponent };